import React, { useEffect, useState } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import useIugu from '../../iugu';
import jquery from 'jquery';
import { useTranslation } from 'react-i18next';


import toastr from 'toastr';
import ButtonLoader from "./ButtonLoader";
import './styles.css';
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import TituloPagina from '../Includes/Titulos';
import api from '../../services/api';
import MaskedInput from 'react-maskedinput';

export default function PagamentoCartao() {
  const history = useHistory();
  const BASE_URL = 'https://agrobrazilapp.com/';
  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  const paymentForm = JSON.parse(sessionStorage.getItem('paymentForm'));
  const selectedPlan = JSON.parse(sessionStorage.getItem('selectedPlan'));
  const address = JSON.parse(sessionStorage.getItem('address'));
  const user_id = sessionStorage.getItem('id');
  const [tempToken, setTempToken] = useState();

  const [sendData, setSendData] = useState();
  const [sendCvv, setSendCvv] = useState();
  const [sendDate, setSendDate] = useState();
  const Iugu = useIugu('86C5C83745B04C7DB074888085A52D16');
  const { t } = useTranslation();

  var axios = require('axios');

  //AccountID ="86C5C83745B04C7DB074888085A52D16";
  var FormData = require('form-data');
  var data = new FormData();
  data.append('USER_TOKEN', USER_TOKEN);
  data.append('USER_EMAIL', USER_EMAIL);
  //toastr options
  toastr.options = {
    "closeButton": false,
    "debug": false,
    "newestOnTop": false,
    "progressBar": false,
    "positionClass": "toast-top-right",
    "preventDuplicates": false,
    "onclick": null,
    "showDuration": "500",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
  }
  function handleChangePlan() {
    toastr.success(t('pages.paymentCard.alerts.changingPlan'));
    var FormData = require('form-data');
    var data = new FormData();
    data.append('USER_EMAIL', USER_EMAIL);
    data.append('USER_TOKEN', USER_TOKEN);
    var config = {
      method: 'post',
      url: ` ${BASE_URL}/v4/users/me/update_subscription`,
      headers: {
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': USER_TOKEN,

      },
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        toastr.success(t('pages.paymentCard.alerts.changedPlan'));
        toastr.success(t('pages.paymentCard.alerts.redirecting'));

        window.location.href = '/checkout/obrigado-cartao';
      })
      .catch(function (error) {
        console.log(error);
      });


  }

  useEffect(() => {
    var config = {
      method: 'post',
      url: `${BASE_URL}/v4/users/me/temporary_token`,
      headers: {
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': USER_TOKEN,
      },
    };

    axios(config).then((response) => setTempToken(response.data.token))
  }, [USER_EMAIL, USER_TOKEN])

  async function authorizedPayment(id, method) {
    toastr.success(t('pages.paymentCard.alerts.sendingConfirmationData'));
    var data = JSON.stringify({
      "token": tempToken,
      "subscription": {
        "card_token": id,
        "iugu_plan_identifier": selectedPlan.identifier,
        "payment_method": method,
        "address_number": address[3],
        "token": tempToken,
        "user_id": user_id,
        "address": {
          "state": address[0],
          "city_id": address[1],
          "zip_code": address[2],
          "address_number": address[3]
        }
      }
    });
    var config = {
      method: 'post',
      url: `${BASE_URL}/v4/users/me/subscriptions`,
      headers: {
        'USER_TOKEN': USER_TOKEN,
        'USER_EMAIL': USER_EMAIL,
        'Content-Type': 'application/json',
      },
      data: data
    };

    axios(config)
      .then(function (response) {
        document.querySelector('.btn-disable').disabled = false;
       console.log(response);
    
        const { message } = response.data.response;

        if (message === "Autorizado") {

          toastr.success(t('pages.paymentCard.alerts.buySuccess'));

          handleChangePlan();


        } else {
        
          toastr.error(t('pages.paymentCard.alerts.buyFail'));
          document.getElementById('hide').classList.add('display-none');
          document.getElementById('show').classList.remove('display-none');
        }

      })
      .catch(function (error) {
        document.getElementById('hide').classList.add('display-none');
        document.getElementById('show').classList.remove('display-none');
        document.querySelector('.btn-disable').disabled = false;
        if (error ) {
          toastr.warning(t('pages.paymentCard.alerts.verifyUserData'));
        }
        console.log(error);
      });

  }

  async function handleSubmitToken(event) {
    event.preventDefault();
    document.getElementById('show').classList.add('display-none');
    document.getElementById('hide').classList.remove('display-none');

    const response = await Iugu.createPaymentToken(event.target);

    const { id, method } = response;
    //envio de dados  pra autorizar o pagamento do cartao
    toastr.success(t('pages.paymentCard.alerts.confirmingData'));
    authorizedPayment(id, method);

    handleValuesData();

  }

  function CustomInput(props) {
    return <MaskedInput {...props} />;
  }
  function handleValuesData() {


    setSendData(document.getElementById('card'));


    setSendCvv(document.getElementById('cvv'));

    setSendDate(document.getElementById('date'));
  }
  function HandleChangeValue() {
    return sendData.replace(/[\d]+/g);

  }
  function HandleChangeValueCvv() {
    return sendCvv.replace(/[\d]+/g);

  }
  function HandleChangeValueDate() {
    return sendDate.replace(/[\d]+/g);

  }

  class CardPayment extends React.Component {

    render() {
      return (

        <form id="payment-form" onSubmit={handleSubmitToken}>
          <p class="text-config"> { t('pages.paymentCard.paymentFor') } {paymentForm}</p>
          <div class="usable-creditcard-form">
            <div class="wrapper">
              <div class="input-group nmb_a">
                <div class="icon ccic-brand"></div>
                <CustomInput mask="1111 1111 1111 1111" autocomplete="off" name="card" id="credit_card_number" id="card" class="credit_card_number" data-iugu="number" placeholder={ t('pages.paymentCard.placeholders.cardNumber') } type="text" required />
                <input type="hidden" value={HandleChangeValue} name="card_num_iugu" />
              </div>
              <div class="input-group nmb_b">
                <div class="icon ccic-cvv"></div>
                <CustomInput mask="111" id="cvv" autocomplete="off" name="ccv" class="credit_card_cvv" data-iugu="verification_value" placeholder={ t('pages.paymentCard.placeholders.cardCVV') } type="text" required />
                <input type="hidden" value={HandleChangeValueCvv} name="card_cvv_iugu" />
              </div>
              <div class="input-group nmb_c">
                <div class="icon ccic-name"></div>
                <input name="cardHolder" class="credit_card_name" data-iugu="full_name" placeholder={ t('pages.paymentCard.placeholders.cardHolder') } type="text" required />
              </div>
              <div class="input-group nmb_d">
                <div class="icon ccic-exp"></div>
                <CustomInput mask="11/11" name="expiry" id="date" autocomplete="off" class="credit_card_expiration" data-iugu="expiration" placeholder={ t('pages.paymentCard.placeholders.cardDate') } type="text" required />
                <input type="hidden" value={HandleChangeValueDate} name="expiry_iugu" />
              </div>
            </div>
            <div class="footer">
              <img src="https://s3-sa-east-1.amazonaws.com/storage.pupui.com.br/9CA0F40E971643D1B7C8DE46BBC18396/assets/cc-icons.e8f4c6b4db3cc0869fa93ad535acbfe7.png" alt={ t('pages.paymentCard.alt.payForms') } border="0" />

            </div>
          </div>

          <div>
            <div >
            <ButtonLoader /></div>
          </div>

        </form>
      );
    }
  }



  useEffect(() => {
    //puxa historico dos dados pra autenticar os dados da pagina 
    api.get(`${BASE_URL}`, {
      headers: {
        'USER_EMAIL': USER_EMAIL,
        'USER_TOKEN': USER_TOKEN,
      }
    }).then(response => {

    }).catch(err => {
      if (err.status === 401) {
        history.push('/');
      }
    });

  }, [USER_EMAIL, USER_TOKEN, history]);


  return (
    <div >
        <script src="https://kit.fontawesome.com/113769f679.js"></script>
     
      <div class="address-container">
        <Header />

        <button class="btn-voltar" onClick={() => { history.go(-1) }}>  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-left" class="svg-inline--fa fa-arrow-left fa-w-14 arruma-arrow" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"></path></svg> </button> <div class="titulopagina"><TituloPagina titulo={ t('pages.paymentCard.processing') } /></div>
        <div class="body-address">

          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/toastr.js/latest/toastr.min.css" />

          <div class="all-inputs-center">
            <h3 class="text-config">{selectedPlan.name} - {selectedPlan.price}</h3>
            <div id="show" >
            <CardPayment />
            </div>
            <div id="hide" class="display-none">
              <h3> { t('pages.paymentCard.processing') } </h3>
            </div>
          </div>

        </div>

        <Footer />
      </div>
    </div>
  );
}
